var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuggestionStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 17,
    viewBox: "0 0 23 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 8.00012C18 8.00012 14.5 5.0001 14.5 1.00012C14.5 5.00012 11.5001 8.00012 7.5 8.00012C11.5 8.00012 14.5 11.5001 14.5 15.0001C14.5 11.5001 18 8.00012 21.5 8.00012Z",
    stroke: "#0DA1EC",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 3.00012C4 3.00012 3 2.14297 3 1.00012C3 2.14298 2.14288 3.00012 1 3.00012C2.14286 3.00012 3 4.00012 3 5.00012C3 4.00012 4 3.00012 5 3.00012Z",
    stroke: "#0DA1EC",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 14.0001C6.66861 13.8199 6.23927 13.3671 6 12.0001C5.79514 13.4921 5.3177 13.9021 4 14.0001C5.49906 14.1333 5.80172 14.6911 6 16.0001C6.12996 14.5793 6.62385 14.1915 8 14.0001Z",
    stroke: "#0DA1EC",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuggestionStar);
export default __webpack_public_path__ + "static/media/suggestionStar.4bee47514fc176188b5edc5299fbfbc7.svg";
export { ForwardRef as ReactComponent };